var render = function render(){
  var _class;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    class: (_class = {}, _class[_vm.$style.checkboxContainer] = true, _class[_vm.$style.selected] = _vm.isChecked(_vm.inputValue), _class[_vm.$style.checkboxDisabled] = _vm.disabled, _class),
    style: {
      '--checkmark-width': _vm.options.width ? _vm.options.width + 'px' : '20px',
      '--checkmark-height': _vm.options.height ? _vm.options.height + 'px' : '20px',
      '--checkmark-selected-color': _vm.options.color ? _vm.options.color : _vm.design['primary-blue']
    }
  }, [_c('input', _vm._b({
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.model,
      expression: "model"
    }],
    attrs: {
      "disabled": _vm.disabled,
      "type": "checkbox"
    },
    domProps: {
      "value": _vm.inputValue,
      "checked": Array.isArray(_vm.model) ? _vm._i(_vm.model, _vm.inputValue) > -1 : _vm.model
    },
    on: {
      "click": _vm.onClickCheckbox,
      "change": function ($event) {
        var $$a = _vm.model,
          $$el = $event.target,
          $$c = $$el.checked ? true : false;
        if (Array.isArray($$a)) {
          var $$v = _vm.inputValue,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.model = $$a.concat([$$v]));
          } else {
            $$i > -1 && (_vm.model = $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
          }
        } else {
          _vm.model = $$c;
        }
      }
    }
  }, 'input', _vm.$attrs, false)), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !_vm.$attrs.disabled,
      expression: "!$attrs.disabled"
    }],
    class: _vm.$style.checkmark
  }), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !_vm.isChecked(_vm.inputValue),
      expression: "!isChecked(inputValue)"
    }],
    class: _vm.$style.emptyCheckmark
  }), _c('p', {
    staticClass: "button-text"
  }, [_vm._v(_vm._s(_vm.label) + " "), _vm._t("afterLabel")], 2)]);

}
var staticRenderFns = []

export { render, staticRenderFns }